import Product from './product';

class UserDataService extends Product {
    static TYPE = 'userData';

    constructor() {
      super(
        UserDataService.TYPE
      );
    }

    saveUserData() {
      return super.saveUserData();
    }

    getUserData() {
      return super.getUserData();
    }
}

export const userDataService = new UserDataService();